<template>
  <HomeworkList class="member-homework" @load="onLoad"></HomeworkList>
</template>

<script>
import HomeworkList from '@/modules/stu/components/HomeworkList.vue';
import { triggerLoaded } from '@/components/LoadContainer.vue';

export default {
  name: 'member-homework-index',
  components: { HomeworkList },
  methods: {
    onLoad() {
      triggerLoaded(this);
    },
  },
};
</script>
<style lang="scss" scoped>
.member-homework {
  padding: 0 32px !important;
  position: relative;
}
</style>
